import { ApolloProvider } from "@apollo/client";
import { client as ApolloClient } from "./graphql/auth";
import TaskManagement from "./pages/TaskManagement";
import "./styles/index.scss";
import "bootstrap/dist/css/bootstrap.css";
import { Provider } from "react-redux";
import store from './redux/store/store'

function App() {
  return (
    <ApolloProvider client={ApolloClient}>
      <Provider store={store}>
        <TaskManagement />
      </Provider>
    </ApolloProvider>
  );
}

export default App;
